import type {RedesignIssue} from '@Components/ai-resdesign-prompt-box/ai-redesign-prompt-box.types';
import {RedesignIssueType} from '@Components/ai-resdesign-prompt-box/ai-redesign-prompt-box.types';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import React, {type ReactElement} from 'react';
import styles from './ai-redesign-issue.module.scss';

interface AiRedesignIssueProps {
  redesignIssue: RedesignIssue;
}

export function AiRedesignIssue({redesignIssue}: AiRedesignIssueProps): ReactElement {
  const getRedesignIssue = (): ReactElement => {
    return (
      <div
        className={`flexbox gap-2 spacing-m-t-2 ${styles.redesignIssueBox}  ${redesignIssue.type === RedesignIssueType.ERROR ? styles.redesignIssueError : styles.redesignIssueWarning}`}
      >
        <Icon icon={redesignIssue.icon} size={IconSize.SIZE_ICON_16} className={styles.redesignIssueIcon} />
        <Text val={redesignIssue.message} size={TextSize.XSMALL} />
      </div>
    );
  };

  return getRedesignIssue();
}
